export const GetCurrencyCode = (locale: string) => {
    switch (locale.toLowerCase())
    {
        case 'en-us':
            return 'USD';
            break;
        case 'en-ca':
            return 'CAD';
            break;
        case 'es-mx':
            return 'MXN';
            break;
        case 'it-it':
        case 'es-es':
        case 'fr-fr':
            return 'EUR'
            break;
        default: 
            break
    }
}